import { render, staticRenderFns } from "./PrivacyPortal.vue?vue&type=template&id=2bfc348c&scoped=true&"
import script from "./PrivacyPortal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPortal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPortal.vue?vue&type=style&index=0&id=2bfc348c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc348c",
  null
  
)

export default component.exports